import { render } from "./PhoneNumberForm.vue?vue&type=template&id=38c16dd0&scoped=true"
import script from "./PhoneNumberForm.vue?vue&type=script&lang=js"
export * from "./PhoneNumberForm.vue?vue&type=script&lang=js"

import "./PhoneNumberForm.vue?vue&type=style&index=0&id=38c16dd0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c16dd0"]])

export default __exports__